import {Routes } from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {permissions } from './../../permissions';
import {AuthGuardService as AuthGuard} from './../../auth-guard.service';
import {InvoicingHeadersComponent} from "./invoicing-headers.component";
import {InvoicingHeadersAddComponent} from "./invoicing-headers-add/invoicing-headers-add.component";
import {InvoicingHeadersViewComponent} from "./invoicing-headers-view/invoicing-headers-view.component";

export const routes: Routes = [{
    path: 'invoicing-headers',
    component: InvoicingHeadersComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Invoices',
        permissions: {
            only: [permissions.INVOICING_READ]
        }
    }
},{
    path: 'invoicing-headers/:id',
    component: InvoicingHeadersComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Invoices',
        permissions: {
            only: [permissions.INVOICING_READ]
        }
    }
},{
    path: 'invoicing-headers/add/:id',
    component: InvoicingHeadersAddComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Add Invoice',
        permissions: {
            only: [permissions.INVOICING_ADD]
        }
    }
},{
    path: 'invoicing-headers/add/:id/lines/:lines',
    component: InvoicingHeadersAddComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Add Invoice',
        permissions: {
            only: [permissions.INVOICING_ADD]
        }
    }
},{
    path: 'invoicing-headers/view/:id',
    component: InvoicingHeadersViewComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'View Invoice',
        permissions: {
            only: [permissions.INVOICING_READ]
        }
    }
}];




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/invoicing-headers/invoicing-headers.routing.ts